import React from 'react'
import { Modal } from '@manychat/manyui'

import { AiTextImprover } from 'apps/aiTextImprover/AiTextImprover'
import { useEditorAiTextImprover } from 'components/MCTextEditor/toolbar/popovers/EditorAiTextImprover/useEditorAiTextImprover'
import { IToolHandler } from 'components/MCTextEditor/types'

import cm from './EditorAiTextImproverMobileModal.module.css'

interface EditorAiTextImproverMobileModalProps {
  onClose: () => void
  onSelect?: IToolHandler
}

export const EditorAiTextImproverMobileModal = ({
  onClose,
  onSelect,
}: EditorAiTextImproverMobileModalProps) => {
  const { text, replaceText, flowNs, maxLength } = useEditorAiTextImprover({ onSelect })

  return (
    <Modal
      open
      disableCloseButton
      overlayClassName={cm.overlay}
      className={cm.modal}
      onRequestClose={onClose}
      noContentPadding
    >
      <AiTextImprover
        newTextMaxLength={maxLength}
        initialText={text}
        onSubmit={replaceText}
        flowNs={flowNs}
        className={cm.textImprover}
      />
    </Modal>
  )
}
